import { EnsaioAliquotaLogResultados } from '@models/ensaio-aliquota-log-resultados.model';
import { EnsaioAliquota } from '@models/ensaio-aliquota.model';
import { ViewEnsaioAliquotaAtual } from '@models/views/view-ensaio-aliquota-atual.model';
import { CancelaEnsaioAliquotaDto } from '../../../back/src/ensaios-aliquotas/dto/cancela-ensaio-aliquota.dto';

import axios from 'axios';

const listaResultadosAliquota = async (
  ensaioAliquotaId: number,
): Promise<EnsaioAliquotaLogResultados[]> => {
  const res = await axios.get<EnsaioAliquotaLogResultados[]>(
    `/ensaios_aliquotas/${ensaioAliquotaId}/log_resultados`,
  );
  return res.data;
};

const listaAliquotasIcpIcpCobre = async (): Promise<
  ViewEnsaioAliquotaAtual[]
> => {
  const res = await axios.get<ViewEnsaioAliquotaAtual[]>(
    '/ensaios_aliquotas/icp_e_icp_cobre',
  );
  return res.data;
};

const removeAliquota = async (
  ensaioAliquotaId: number,
  cancelaEnsaioAliquotaDto: CancelaEnsaioAliquotaDto,
): Promise<EnsaioAliquota> => {
  const res = await axios.post(
    `/ensaios_aliquotas/${ensaioAliquotaId}`,
    cancelaEnsaioAliquotaDto,
  );
  return res.data;
};

export default {
  listaResultadosAliquota,
  listaAliquotasIcpIcpCobre,
  removeAliquota,
};
